const URL_SECURISED_REGEX = /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/;

export const getIsValidURLFormat = (str: string): boolean => {
  const pattern = new RegExp(URL_SECURISED_REGEX, 'i');
  return pattern.test(str);
};
